import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { QueryClientProvider } from "@tanstack/react-query"

import "./estilos/tokens.css"
import "./estilos/base.css"

import { queryClient } from "./api/query"
import { ProvedorDeSessao } from "./sessao/Sessao"
import { ProvedorDeTema } from "./casca/Tema"
import { ProvedorDeEscala } from "./casca/Escala"
import { AvisoDeNovaVersao } from "./casca/AvisoDeNovaVersao"
import { App } from "./App"

const raiz = document.getElementById("raiz")
if (!raiz) throw new Error("Faltou <div id=\"raiz\"> no index.html")

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ProvedorDeTema>
      <ProvedorDeEscala>
        <ProvedorDeSessao>
          <BrowserRouter>
            <App />
          </BrowserRouter>
          {/* Na raiz, e não na casca: vale também para quem está na tela de login. */}
          <AvisoDeNovaVersao />
        </ProvedorDeSessao>
      </ProvedorDeEscala>
      </ProvedorDeTema>
    </QueryClientProvider>
  </StrictMode>,
)
